import { TabularTypeAdapter } from 'app/model/adapters/dataflow/formatAdapters/tabular-type.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned, SelfHostedIntegrationRuntime } from 'shell-models-lib';
import { OracleSettings } from 'app/model/dataflow/dataset-settings/oracle-settings';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { IntegerDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleSettings)
})
export class OracleAdapter extends TabularTypeAdapter {
    public override async toSourceDSL(setting: OracleSettings): Promise<string[]> {
        const props = await super.toSourceDSL(setting);
        props.push(`store: '${DatasetFormatType.Oracle}'`);
        const linkedService = (setting.owner as DataFlowSource).sourceLinkedService;
        if (linkedService.integrationRuntime instanceof SelfHostedIntegrationRuntime) {
            props.push('staged: true');
        }
        if (setting.timeout.expression) {
            props.push(
                `timeout: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    setting.timeout,
                    IntegerDataFlowType.TYPE
                )}`
            );
        }
        return props;
    }

    public override async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<OracleSettings> {
        const setting: OracleSettings = (await super.toSourceModel(owner, configs, handledConfigs)) as OracleSettings;
        if (configs.has('timeout')) {
            setting.timeout = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('timeout'),
                owner,
                IntegerDataFlowType.TYPE
            );
        }
        return setting;
    }

    public override toSinkDSL(): never {
        throw new Error(`${DatasetFormatType.Oracle} is only supported in dataflow source.`);
    }

    public override toSinkModel(): never {
        throw new Error(`${DatasetFormatType.Oracle} is only supported in dataflow source.`);
    }

    protected override _generateSetting(owner: DataFlowSource): OracleSettings {
        const result = Owned.create<OracleSettings>(OracleSettings.MODEL, owner);
        result.initialize(undefined);
        return result;
    }
}
